<template>
  <span>
    <a-popconfirm
      :visible="popconfirmVisible"
      :disabled="false"
      okText="确定"
      cancelText="取消"
      @cancel="popCancel"
      @confirm="popComfirm">
      <template slot="title" >
        <h4>请录入以下队员的监护人电话后再重新购买保险</h4>
        <a-row type="flex" align="middle" :gutter="[16,16]" v-for="(npp, index) in this.needPhonePlayers" :key="index">
          <a-col :span="24"><a-input :addon-before="npp.name" addon-after="*必填" v-model="npp.phone" placeholder="请输入监护人电话"/></a-col>
        </a-row>
      </template>
      <a-button :disabled="btnDisabled" icon="money-collect" type="primary" @click="buyInsurance">{{ name }}</a-button>
    </a-popconfirm>
  </span>
</template>
<script>
import matchFun from '@comm/utils/matchFun'
export default {
  components: {
  },
  props: {
    needPhonePlayers: {
      type: Array,
      default: function () { return [] }
    },
    name: {
      type: String
    },
    agencyId: {
      type: Number
    },
    btnDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      popconfirmVisible: false
    }
  },
  methods: {
    show () {
      this.popconfirmVisible = true
    },
    popCancel () {
      this.popconfirmVisible = false
    },
    buyInsurance () {
      // this.$refs.insuranceType.show()
      this.$emit('buyInsurance')
    },
    popComfirm () {
      let params = {
        agencyId: this.agencyId,
        phones: []
      }
      // 检查手机号是否全都绑定了
      for (let i = 0; i < this.needPhonePlayers.length; i++) {
        let player = this.needPhonePlayers[i]
        let phone = player.phone
        if (phone == undefined || phone === '') {
          this.$message.error('请输入监护人手机号')
          return
        }
        if (!matchFun.phoneFun(phone)) {
          this.$message.error('手机号码不正确')
          return
        }
        params.phones.push({cardId: player.cardId, phone: player.phone})
      }
      this.$api.join.bindPlayerGuardianPhone(params).then(res => {
        if (res.status === 0) {
          this.$message.success(`成功`)
          this.popCancel()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/comm/components/join/pay/BuyInsuranceBtn.vue